'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GADVENTURES_PARTICIPATION_WAIVER = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GADVENTURES_PARTICIPATION_WAIVER = exports.GADVENTURES_PARTICIPATION_WAIVER = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'formParticipationWaiver.stubText',
    defaultMessage: '{waiverText}',
    values: {
        waiverText: _react2.default.createElement(
            'div',
            { className: 'waiver-text' },
            _react2.default.createElement(
                'h2',
                { className: 'h2-size center-text hero-text' },
                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part1.title1',
                    defaultMessage: 'Waiver Of Liability' })
            ),
            _react2.default.createElement(
                'div',
                { className: 'waiver-intro' },
                _react2.default.createElement(
                    'p',
                    { className: 'subheading' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part1.text1',
                        defaultMessage: 'By agreeing to the terms of this agreement you will waive certain legal rights.' })
                ),
                _react2.default.createElement(
                    'p',
                    { className: 'subheading no-pad' },
                    _react2.default.createElement(
                        'strong',
                        null,
                        _react2.default.createElement(
                            'em',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part1.text2',
                                defaultMessage: 'Please read carefully' })
                        )
                    )
                )
            ),
            _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text1.1',
                    defaultMessage: 'TO:' }),
                '\xA0',
                _react2.default.createElement(
                    'strong',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text1.2',
                        defaultMessage: 'G Adventures Inc.' })
                ),
                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text1.3',
                    defaultMessage: ', and its subsidiaries, affiliates and related companies including, but not limited to, G Adventures Limited and The Expedition Shipping Company Limited, and their respective directors, officers, employees, subcontractors, suppliers, agents, guides, volunteers, independent contractors, representatives, owners, insurers, successors and assigns (individually and collectively, \u201CG ADVENTURES\u201D)' })
            ),
            _react2.default.createElement(
                'div',
                { className: 'simply-put' },
                _react2.default.createElement(
                    'strong',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text2.1',
                        defaultMessage: 'Simply Put:' })
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text2.2',
                        defaultMessage: 'I am providing this Waiver to the companies and people involved in organizing and providing the services I have requested in connection with my travel arrangements.' })
                )
            ),
            _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                    'strong',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text3.1',
                        defaultMessage: '"Activities"' })
                ),
                '\xA0',
                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text3.2',
                    defaultMessage: 'means the activities and services that G Adventures will be providing, arranging or organizing on my behalf depending on my chosen itinerary.' })
            ),
            _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text4',
                    defaultMessage: 'These may include: ' })
            ),
            _react2.default.createElement(
                'ul',
                null,
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text4.1',
                        defaultMessage: 'participation in an adventure travel tour' })
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text4.2',
                        defaultMessage: 'canyoneering' })
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text4.3',
                        defaultMessage: 'caving' })
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text4.4',
                        defaultMessage: 'cycling' })
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text4.5',
                        defaultMessage: 'hang-gliding' })
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text4.6',
                        defaultMessage: 'horse riding and other equine activities' })
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text4.7',
                        defaultMessage: 'hot air balloon rides' })
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text4.8',
                        defaultMessage: 'mountain biking' })
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text4.9',
                        defaultMessage: 'parasailing' })
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text4.10',
                        defaultMessage: 'rock/rope climbing' })
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text4.11',
                        defaultMessage: 'rappelling' })
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text4.12',
                        defaultMessage: 'zip lining' })
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text4.13',
                        defaultMessage: 'scuba diving' })
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text4.14',
                        defaultMessage: 'helicopter activities' })
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text4.15',
                        defaultMessage: 'white water rafting' })
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text4.16',
                        defaultMessage: 'travel in jet boats/speed boats' })
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text4.17',
                        defaultMessage: 'sailing' })
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text4.18',
                        defaultMessage: 'trekking' })
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text4.19',
                        defaultMessage: 'mountaineering' })
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text4.20',
                        defaultMessage: 'surfing' })
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text4.21',
                        defaultMessage: 'paragliding' })
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text4.22',
                        defaultMessage: 'travel in public and private transportation (including to and from tour areas) ' })
                )
            ),
            _react2.default.createElement(
                'h2',
                { className: 'h2-size' },
                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part3.title1',
                    defaultMessage: 'ACKNOWLEDGMENT \u2013 HEALTH & SAFETY' })
            ),
            _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part3.text1',
                    defaultMessage: 'I am aware that the physical exertion required to participate in the Activities can activate or aggravate pre-existing injuries, conditions, or congenital defects.' })
            ),
            _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part3.text2',
                    defaultMessage: 'I acknowledge that I should seek medical advice if I know or suspect that my physical condition may be incompatible with the Activities.' })
            ),
            _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part3.text3',
                    defaultMessage: 'I acknowledge that I am required to wear approved safety equipment while participating in certain Activities.  I am aware that there are guides and instructors available to answer any questions I may have as to the proper use of any equipment.' })
            ),
            _react2.default.createElement(
                'div',
                { className: 'simply-put' },
                _react2.default.createElement(
                    'strong',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part3.text4.1',
                        defaultMessage: 'Simply Put:' })
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part3.text4.2',
                        defaultMessage: 'I understand that the Activities may require physical exertion and it is my responsibility to make sure I am healthy enough to participate. I will use the recommended safety equipment and ask questions if I am unsure about how to properly or safely use equipment. ' })
                )
            ),
            _react2.default.createElement(
                'h2',
                { className: 'h2-size' },
                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part4.title1',
                    defaultMessage: 'ASSUMPTION OF RISKS' })
            ),
            _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part4.text1',
                    defaultMessage: 'I am aware that the Activities involve many risks, dangers and hazards which may include but are not limited to:' })
            ),
            _react2.default.createElement(
                'ul',
                null,
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part4.text1.1',
                        defaultMessage: 'personal injury and/or death;' })
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part4.text1.2',
                        defaultMessage: 'travel to remote areas without access to medical facilities or treatment' })
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part4.text1.3',
                        defaultMessage: 'changing weather conditions;' })
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part4.text1.4',
                        defaultMessage: 'interactions or encounters with wildlife; ' })
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part4.text1.5',
                        defaultMessage: 'equipment malfunctions' })
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part4.text1.6',
                        defaultMessage: 'negligence of other participants or guides;' })
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part4.text1.7',
                        defaultMessage: 'negligence on the part of the G Adventures, including failure to safeguard or protect from the risks or dangers of the Activities' })
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part4.text1.8',
                        defaultMessage: 'consumption of alcohol;' })
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part4.text1.9',
                        defaultMessage: 'collisions with vehicles, equipment or structures;' })
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part4.text1.10',
                        defaultMessage: 'becoming lost or separated from guides or other participants; and the failure to remain within designated areas.' })
                )
            ),
            _react2.default.createElement(
                'div',
                { className: 'simply-put' },
                _react2.default.createElement(
                    'strong',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part4.text2.1', defaultMessage: 'Simply Put:' })
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part4.text2.2',
                        defaultMessage: 'I acknowledge that there are numerous risks I may face during my involvement in the Activities including the risks listed here.' })
                )
            ),
            _react2.default.createElement(
                'h2',
                { className: 'h2-size' },
                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part5.title1',
                    defaultMessage: 'ALCOHOL AND ILLEGAL SUBSTANCES' })
            ),
            _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part5.text1.1',
                    defaultMessage: 'If I use, consume or am under the influence of alcohol or illegal drugs prior to or while engaging in the Activities,' }),
                '\xA0',
                _react2.default.createElement(
                    'strong',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part5.text1.2',
                        defaultMessage: 'I ASSUME AND ACCEPT ALL RISKS, DANGERS AND HAZARDS THAT MAY RESULT FROM THIS INCLUDING THE POSSIBILITY OF PERSONAL INJURY, DEATH, PROPERTY DAMAGE AND LOSS' })
                ),
                '\xA0',
                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part5.text1.3',
                    defaultMessage: ', even in the event of negligence or fault by G Adventures or third parties, and will indemnify G Adventures from any and all liability for any damage to property or personal injury to any third party, resulting from my participation in the Activities, while, during or after consumption of illegal drugs or alcohol.' })
            ),
            _react2.default.createElement(
                'div',
                { className: 'simply-put' },
                _react2.default.createElement(
                    'strong',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part5.text2.1', defaultMessage: 'Simply Put:' })
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part5.text2.2',
                        defaultMessage: 'If I consume alcohol or illegal drugs before or during my involvement in the Activities I am responsible for any loss, injury or damage I cause to myself or others.' })
                )
            ),
            _react2.default.createElement(
                'h2',
                { className: 'h2-size' },
                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part6.title1',
                    defaultMessage: 'I AM AWARE OF THE RISKS, DANGERS, AND HAZARDS ASSOCIATED WITH THE ACTIVITIES.' })
            ),
            _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part6.text1',
                    defaultMessage: 'I am not relying on any oral or written representations or statements made by G Adventures about the safety of the Activities other than what is stated in this Waiver. ' })
            ),
            _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                    'strong',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part6.text2',
                        defaultMessage: 'I freely accept and fully assume these risks and the possibility of injury and loss resulting from my participation in the Activities.' })
                )
            ),
            _react2.default.createElement(
                'div',
                { className: 'simply-put' },
                _react2.default.createElement(
                    'strong',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part6.text3.1', defaultMessage: 'Simply Put:' })
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part6.text3.2',
                        defaultMessage: 'I understand and accept the risks of participating in the Activities. I am relying on the statements about the risk contained in this Wavier as the definitive source of information about the safety of the Activities over any other communications or materials.' })
                )
            ),
            _react2.default.createElement(
                'h2',
                { className: 'h2-size' },
                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part7.title1',
                    defaultMessage: 'RELEASE OF LIABILITY, WAIVER OF CLAIMS, AND INDEMNITY AGREEMENT' })
            ),
            _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part7.text1',
                    defaultMessage: 'In consideration of G Adventures allowing me to participate in the Activities I agree::' })
            ),
            _react2.default.createElement(
                'ol',
                null,
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part7.text2.1',
                            defaultMessage: 'In the event that I, or my next of kin, suffer any loss, damage, expense or injury from my participation in the Activities' }),
                        '\xA0',
                        _react2.default.createElement(
                            'strong',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part7.text2.2',
                                defaultMessage: 'INCLUDING THOSE CAUSED BY THE RISKS SPECIFICALLY OUTLINED IN THIS WAIVER, I AGREE TO WAIVE ANY AND ALL CLAIMS' })
                        ),
                        '\xA0',
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part7.text2.3',
                            defaultMessage: 'I have or may have in the future against' }),
                        '\xA0',
                        _react2.default.createElement(
                            'strong',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part7.text2.4',
                                defaultMessage: 'G ADVENTURES' })
                        ),
                        '\xA0',
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part7.text2.5',
                            defaultMessage: 'and to' }),
                        '\xA0',
                        _react2.default.createElement(
                            'strong',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part7.text2.6',
                                defaultMessage: 'RELEASE G ADVENTURES' })
                        ),
                        '\xA0',
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part7.text2.7',
                            defaultMessage: 'from any and all liability;' })
                    )
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'strong',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part7.text3.1',
                                defaultMessage: 'TO HOLD HARMLESS AND INDEMNIFY G ADVENTURES' })
                        ),
                        '\xA0',
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part7.text3.2',
                            defaultMessage: 'from any and all liability for damage to property or personal injury to any third party resulting from my participation in the Activities;' })
                    )
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part7.text4',
                            defaultMessage: 'Any litigation involving the parties to this Agreement shall be brought solely within the Province of Ontario and shall be within the exclusive jurisdiction of the Courts of the Province of Ontario.' })
                    )
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part7.text5',
                            defaultMessage: 'This Agreement shall be effective and binding upon my heirs, next of kin, executors, administrators, assigns and representatives, in the event of my death or incapacity.' })
                    )
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part7.text6',
                            defaultMessage: 'This Agreement and any rights, duties, and obligations as between the parties to this agreement shall be governed by and interpreted solely in accordance with the laws of the Province of Ontario and no other jurisdiction.' })
                    )
                )
            ),
            _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                    'strong',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part8.text1',
                        defaultMessage: 'I HAVE READ AND UNDERSTAND THIS AGREEMENT PRIOR TO CHECKING THE BOX BELOW CONFIRMING MY AGREEMENT.' })
                )
            ),
            _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part9.text1',
                    defaultMessage: 'I am aware that by checking the box below I am waiving certain legal rights which I may have against G Adventures.' })
            ),
            _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                    'strong',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part10.text1',
                        defaultMessage: 'FOR PARTICIPANTS OF MINORITY AGE: I hereby certify that I, parent/guardian with legal responsibility for this participant of minority age, do consent and agree to his/her release of all G ADVENTURES, and for myself, my heirs, assigns, and next of kin, I release and agree to indemnify G ADVENTURES for any and all liabilities incident to this participant of minority age\u2019s participation in the Activities.' })
                )
            )
        )
    }
});


//////////////////
// WEBPACK FOOTER
// ./app/components/RequirementSet/forms/Waiver_GAdventures.js
// module id = 1331
// module chunks = 0